import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
  useTheme,
  useMediaQuery,
} from '@mui/material';

// Material UI icons (example set)
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import EmailIcon from '@mui/icons-material/Email';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'; 
import SpotifyIcon from '../utils/spotify-icon'

const Music: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        p: 4,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography
        variant={isMobile ? 'h4' : 'h3'}
        sx={{ mb: 4, color: theme.palette.secondary.main }}
      >
        Latest Video
      </Typography>

      {/* Card container for the video + links */}
      <Card
        sx={{
          maxWidth: isMobile ? '90%' : 600,
          mx: 'auto',
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.secondary,
          p: 2,
        }}
      >
        <CardContent sx={{ textAlign: 'center' }}>
          {/* YouTube Embed */}
          <Box
            sx={{
              position: 'relative',
              overflow: 'hidden',
              width: '100%',
              // 16:9 aspect ratio
              pt: '56.25%', // (9/16)*100
              mb: 2,
            }}
          >
            <Box
              component="iframe"
              src="https://www.youtube.com/embed/jwRU8cPRX-w"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 0,
              }}
            />
          </Box>

          <Typography variant="body1" sx={{ mb: 3 }}>
            Check out our latest release!
          </Typography>

          {/* Social/links row */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              gap: 2,
              flexWrap: 'wrap', 
            }}
          >
            {/* Facebook */}
            <IconButton
              component="a"
              href="https://www.facebook.com/strikethetower/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: theme.palette.text.secondary }}
            >
              <FacebookIcon fontSize="large" />
            </IconButton>

            {/* Spotify */}
            <IconButton
              component="a"
              href="https://open.spotify.com/artist/6LbrbRaWTnKFXvy7TTVHFX"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: theme.palette.text.secondary }}
            >
              <SpotifyIcon fontSize="large" />
            </IconButton>

            {/* YouTube */}
            <IconButton
              component="a"
              href="https://www.youtube.com/@strikethetower2042"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: theme.palette.text.secondary }}
            >
              <YouTubeIcon fontSize="large" />
            </IconButton>

            {/* Email */}
            <IconButton
              component="a"
              href="mailto:Strikethetower@gmail.com"
              sx={{ color: theme.palette.text.secondary }}
            >
              <EmailIcon fontSize="large" />
            </IconButton>

            {/* PayPal or Payment */}
            <IconButton
              component="a"
              href="https://www.paypal.com/Segarox"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: theme.palette.text.secondary }}
            >
              <AttachMoneyIcon fontSize="large" />
            </IconButton>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Music;
